import { render, staticRenderFns } from "./useHistory.vue?vue&type=template&id=41c2d8f9&scoped=true&"
import script from "./useHistory.vue?vue&type=script&lang=js&"
export * from "./useHistory.vue?vue&type=script&lang=js&"
import style0 from "./useHistory.vue?vue&type=style&index=0&id=41c2d8f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c2d8f9",
  null
  
)

export default component.exports